import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const ErrorContainer = ({ errors }) => {
  if (_.isArray(errors) && !_.isEmpty(errors)) {
    return (
      <div className="error">
        {errors.map((error, index) => (
          <p key={index}>{error}</p>
        ))}
      </div>
    );
  }
  return null;
};

ErrorContainer.propTypes = {
  errors: PropTypes.array
};

export default ErrorContainer;
